import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";

const ACTIVE_TITLE = "Neurobloom | Speak local. Sell more. for Business";
const AWAY_MESSAGES = [
  "Psst... AI is lonely. 🤖",
  "Still here. Are you? 👀",
  "We miss you! 🥺",
  "Don't leave us! 😢",
];

function App() {
  useEffect(() => {
    document.title = ACTIVE_TITLE;

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.type = "image/png";
    link.href = "/neurobloom-logo.png";

    let awayInterval = null;
    let messageIndex = 0;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        document.title = AWAY_MESSAGES[messageIndex % AWAY_MESSAGES.length];
        messageIndex++;
        awayInterval = setInterval(() => {
          document.title = AWAY_MESSAGES[messageIndex % AWAY_MESSAGES.length];
          messageIndex++;
        }, 3000);
      } else {
        clearInterval(awayInterval);
        awayInterval = null;
        messageIndex = 0;
        document.title = ACTIVE_TITLE;
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(awayInterval);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/:section" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
